import { KmapBinomialCoefficient } from './KmapBinomialCoefficient';

window.customElements.define('kmap-binomial-coefficient', KmapBinomialCoefficient);
